import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CascadeSegment } from './cascade-segment';
import { useBoilersState } from 'z3k-settings/climatic/boilers/lib/useBoilersState';
export function CascadeList() {
    const { state } = useBoilersState();
    const { cascades } = state;
    return (_jsx(_Fragment, { children: cascades.map((cascade, i) => (_jsx(CascadeSegment, { cascade_settings: cascade }, cascade.id))) }));
}
